import chestAnimationData from "../assets/chest.json";

/** Nombre minimum de bonnes réponses sur 15 pour obtenir un coffre (80 %). */
export const CHEST_MIN_CORRECT = 12;

/**
 * Frame où le coffre est entièrement ouvert.
 * L'anim complète (op={chestAnimationData.op}) referme le coffre : on s'arrête avant.
 */
export const CHEST_ANIMATION_HOLD_FRAME = 52;

/** Frame à partir de laquelle la pierre commence à sortir (après ouverture visible du couvercle). */
export const CHEST_GEM_REVEAL_FRAME = 44;

export { chestAnimationData };
